/**
 * Created by evgeny on 13.06.2024
 */

(function () {
    if (engine === "cocos2d") {
        UnitView.prototype.hideTouchArea = function () {
            if (this.savedTouchArea) {
                this.savedTouchArea.removeFromParent();
                this.savedTouchArea = undefined;
            }
        };

        UnitView.prototype.showTouchArea = function () {
            this.hideTouchArea();

            const used = {};
            const pool = [];
            let points = [];
            const siblings = [{ x: 1, y: 0 }, { x: 0, y: -1 }, { x: -1, y: 0 }, { x: 0, y: 1 }];

            const directions = [];
            let i = 0, j = 0, k = 1, l = 0, x = 0, y = 0;
            for (; k < 6;) {
                x += siblings[j % 4].x;
                y += siblings[j % 4].y;
                directions.push(cc.p(x, y));

                i += 1;

                if (i >= k) {
                    j += 1;
                    l += 1;
                    i = 0;
                }

                if (l >= 2) {
                    k += 1;
                    l = 0;
                }
            }

            const acceptTouch = function (point) {
                point = this.convertToWorldSpace(point);
                return this.checkTouchInside(cleverapps.inputDispatcher.createTouch({ location: point }));
            }.bind(this);

            y = Math.floor(this.height / 2);
            for (x = 0; x < this.width; ++x) {
                const point = cc.p(x, y);

                if (acceptTouch(point)) {
                    pool.push(point);
                    break;
                }
            }

            for (i = 0; i < pool.length; ++i) {
                const current = pool[i];

                for (j = 0; j < directions.length; ++j) {
                    const next = cc.p(current.x + directions[j].x, current.y + directions[j].y);
                    const key = (next.x + 1000) + (next.y + 1000) * 10000;

                    if (used[key]) {
                        continue;
                    }
                    used[key] = true;

                    if (!acceptTouch(next)) {
                        continue;
                    }

                    for (k = 0; k < siblings.length; ++k) {
                        if (!acceptTouch(cc.p(next.x + siblings[k].x, next.y + siblings[k].y))) {
                            points.push(next);
                            pool.push(next);
                            break;
                        }
                    }

                    if (k !== siblings.length) {
                        break;
                    }
                }
            }

            points = points.filter((point, index) => !(index % 5));

            this.savedTouchArea = new cc.DrawNode();
            this.savedTouchArea.setAnchorPoint(0, 0);
            this.savedTouchArea.setContentSize2(this.width, this.height);
            this.savedTouchArea.drawDots(points, 1.2, cc.color(0, 0, 200, 255));
            this.savedTouchArea.setLocalZOrder(1000);
            this.addChild(this.savedTouchArea);
        };
    }

    Unit.CreateDebug = function (unit, cell) {
        if (!cell) {
            cell = Merge2.current.finalize.getScreenCenterCell();
            cell = Merge2.current.field.findEmptySlot(cell.x, cell.y, unit, { radius: 0 });
        }

        if (cell && Merge2.current.field.isValid(cell.x, cell.y)) {
            unit = new Unit(unit);
            unit.setPosition(cell.x, cell.y);
            Merge2.current.field.addUnit(cell.x, cell.y, unit);
            Merge2.current.field.onAddUnit(cell.x, cell.y, unit);
            Merge2.current.field.onUnitAvailable(unit);

            const data = { unit, debug: true };
            Field.mapEvent(Field.SPAWN, data);
            cleverapps.tutorial.trigger(Field.SPAWN);

            return true;
        }
    };

    Unit.prototype.debugRemove = function (isDblClick) {
        if (cleverapps.flags.toggleDebugClick) {
            return;
        }

        if (cleverapps.focusManager.isFocused() || Merge2.current.field.getUnit(this.x, this.y) !== this) {
            return false;
        }
        if (isDblClick && [Merge2Generator, CupComponent, ThirdElement].some((Component) => this.findComponent(Component))) {
            return false;
        }
        const collectible = this.findComponent(Collectible);
        const grounded = this.findComponent(Grounded);
        if (collectible && !grounded) {
            return false;
        }
        if (this.view && this.view.getParent() === Merge2.current.field.getMapView().animations) {
            return;
        }

        this.onDestruction(grounded);
        this.remove(true);
        Merge2.current.counter.trigger(1);
    };

    UnitView.prototype.handleClick = cleverapps.extendFunc(UnitView.prototype.handleClick, function (...args) {
        if (cleverapps.flags.toggleDebugClick) {
            return this._super(...args);
        }

        if (cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.c) && cleverapps.config.name !== "wordsoup") {
            const map = Merge2.current.field;
            const position = map.findEmptySlot(this.unit.x, this.unit.y, this.unit);
            if (position && !["thirdelement"].includes(this.unit.code)) {
                const unit = new Unit(this.unit);
                unit.setPosition(position.x, position.y);
                map.addUnit(unit.x, unit.y, unit);
                map.onAddUnit(unit.x, unit.y, unit);
                map.onUnitAvailable(unit);
                unit.onAdd();
            }
            return;
        }

        if (cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.x)) {
            const url = cleverapps.RestClient.standsWeb(`/?unitsDemo=${cleverapps.meta.selectedLocationId()}&code=${this.unit.code}`);
            connector.platform.openUrl(url);
            return;
        }

        const locked = this.unit.findComponent(LockedComponent);
        if (cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.l) && locked) {
            if (locked.isLocked()) {
                locked.unlock();
            } else {
                locked.lock();
            }
            return;
        }

        if (this._toolLastClick + PointerHandler.DOUBLE_CLICK_WAIT > Date.now()) {
            const unitRemoved = this.unit.debugRemove(true);
            if (unitRemoved !== false) {
                if (this.unit.findComponent(Grounded)) {
                    const pos = { x: this.unit.x, y: this.unit.y };
                    // add unit
                    const unit = new Unit({ code: this.unit.code, stage: this.unit.stage });
                    unit.setPosition(pos.x, pos.y);
                    Merge2.current.field.addUnit(pos.x, pos.y, unit);
                    Merge2.current.field.onAddUnit(pos.x, pos.y, unit);
                }

                return true;
            }
        }

        this._toolLastClick = Date.now();
        return this._super(...args);
    });
}());

cleverapps.override(cleverapps.Tool, {
    game: {
        win: undefined,
        lose: undefined,

        thirdElement: function () {
            const field = Merge2.current.field;

            let cell = field.getScreenCenterCell();
            cell = field.findEmptySlot(cell.x, cell.y);

            const unit = {
                stage: 4,
                code: "a"
            };

            if (cell) {
                const offer = new Unit({
                    code: "thirdelement", stage: 0, prize: unit
                });

                offer.setPosition(cell.x, cell.y);
                field.addUnit(cell.x, cell.y, offer);
                field.onAddUnit(cell.x, cell.y, offer);
                offer.findComponent(ThirdElement).onAppearance();
            }
        }

    }
    
});